@if (formData) {
  <h5
    class="mobi-ui-card-fullwidth mobi-ui-font-h6 mobi-ui-text-has-border mobi-ui-padding-t-md"
  >
    {{
      'calc_selection'
        | texts
          : {
              context: 'primcalc',
              default: 'Leistungswahl',
            }
    }}
  </h5>
  <ul class="mobi-ui-list-silent is-block mobi-ui-font-size-50">
    <li>
      <div>
        {{
          'bike_benefit_1'
            | texts
              : {
                  context: 'primcalc',
                  default: 'Beschädigungen (inkl. Stromwirkungsschäden)',
                }
        }}
        @if (formData[formId + '--ins_coverage']?.damage) {
          <mobi-ui-icon-major name="tik_checkbox" />
        }
        @if (!formData[formId + '--ins_coverage']?.damage) {
          <mobi-ui-icon-major name="the_x" size="sm" />
        }
      </div>
    </li>
    <li>
      <div>
        {{
          'bike_benefit_2'
            | texts
              : {
                  context: 'primcalc',
                  default: 'Assistance und Rechtsschutzversicherung',
                }
        }}
        @if (formData[formId + '--ins_coverage']?.assistance) {
          <mobi-ui-icon-major name="tik_checkbox" />
        }
        @if (!formData[formId + '--ins_coverage']?.assistance) {
          <mobi-ui-icon-major name="the_x" size="sm" />
        }
      </div>
    </li>
    <li>
      <div>
        {{
          'bike_benefit_3'
            | texts
              : {
                  context: 'primcalc',
                  default: 'Diebstahl',
                }
        }}
        @if (formData[formId + '--ins_coverage']?.theft) {
          <mobi-ui-icon-major name="tik_checkbox" />
        }
        @if (!formData[formId + '--ins_coverage']?.theft) {
          <mobi-ui-icon-major name="the_x" size="sm" />
        }
      </div>
    </li>
  </ul>
  <dl
    class="mobi-ui-card-fullwidth mobi-ui-list-silent is-description-list mobi-ui-margin-t-md mobi-ui-text-has-border mobi-ui-font-size-50"
  >
    <dt class="mobi-ui-font-h6">
      {{ 'ins_sum' | texts: { context: 'primcalc', default: 'Versicherungssumme' } }}
    </dt>
    <dd>CHF&nbsp;{{ formatNumber(formData[formId + '--ins_sum'], '0,0.00') }}</dd>
  </dl>
  <dl
    class="mobi-ui-card-fullwidth mobi-ui-list-silent is-description-list mobi-ui-margin-t-md mobi-ui-text-has-border mobi-ui-font-size-50"
  >
    <dt class="mobi-ui-font-h6">
      {{ 'deductible' | texts: { context: 'primcalc', default: 'Selbstbehalt' } }}
    </dt>
    <dd>
      @if (formData[formId + '--ins_age'] === 'under_26') {
        CHF&nbsp;{{
          formatNumber(formData[formId + '--ins_deductible_under_26'], '0,0.00')
        }}
      } @else {
        CHF&nbsp;{{
          formatNumber(formData[formId + '--ins_deductible_over_26'], '0,0.00')
        }}
      }
    </dd>
  </dl>
  <dl
    class="mobi-ui-card-fullwidth mobi-ui-list-silent is-description-list mobi-ui-margin-t-md mobi-ui-text-has-border"
  >
    <dt class="mobi-ui-font-h6">
      {{
        'contract_duration' | texts: { context: 'primcalc', default: 'Vertragslaufzeit' }
      }}
    </dt>
    <dd>
      @if (formData[formId + '--ins_start'] === 'today') {
        <span> {{ today }}&nbsp;-&nbsp;{{ contractEnd }} </span>
      } @else {
        {{ contractStart }}&nbsp;-&nbsp;{{ contractEnd }}
      }
    </dd>
  </dl>
  <div class="mobi-ui-text-center mobi-ui-padding-b-md mobi-ui-margin-t-lg">
    <div class="mobi-ui-price-major is-center">
      <span class="mobi-ui-price-unit-major">CHF</span>
      <span class="mobi-ui-price-value-major premium-value">{{
        formatNumber(result.annual_premium, '0,0.00')
      }}</span>
    </div>
    <span>
      {{ 'annual_premium' | texts: { context: 'primcalc', default: 'Jahresprämie' } }}
    </span>
  </div>
}
